var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c("authentication-service-provider", {
        ref: "authenticationServiceProvider",
        on: {
          "signup-success": _vm.onSignupSuccess,
          "signup-social-success": _vm.onSignupSuccess,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({
              signUp,
              signupSocial,
              goToLogin,
              loaders,
              forms,
              errorMessage,
            }) {
              return [
                _c(
                  "div",
                  { staticClass: "wrapper" },
                  [
                    _c("locale-changer", { staticClass: "pb-3" }),
                    _c(
                      "div",
                      { staticClass: "form-wrapper" },
                      [
                        _c("h1", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("auth.signUpPayment.title")) +
                              " "
                          ),
                        ]),
                        _c(
                          "v-alert",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: errorMessage,
                                expression: "errorMessage",
                              },
                            ],
                            attrs: {
                              border: "left",
                              color: "red",
                              type: "error",
                            },
                          },
                          [_vm._v(" " + _vm._s(errorMessage) + " ")]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "button-google",
                            attrs: {
                              block: "",
                              "x-large": "",
                              type: "submit",
                              elevation: "0",
                              outlined: "",
                              disabled: loaders.socialSignup || loaders.signUp,
                              loading: loaders.socialSignup,
                              color: "secondary",
                            },
                            on: {
                              click: function ($event) {
                                return signupSocial("google")
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "mr-2",
                              attrs: {
                                src: require("@/assets/img/logos/google.png"),
                                alt: "google",
                              },
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("auth.signUp.signUpWithGoogle"))
                              ),
                            ]),
                          ]
                        ),
                        _c("p", { staticClass: "line-through" }, [
                          _vm._v(" " + _vm._s(_vm.$t("auth.global.or")) + " "),
                        ]),
                        _c("validation-observer", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ invalid }) {
                                  return [
                                    _c(
                                      "v-form",
                                      {
                                        nativeOn: {
                                          submit: function ($event) {
                                            $event.preventDefault()
                                            return signUp()
                                          },
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "email",
                                            rules: "required|email",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label:
                                                          _vm.$t(
                                                            "auth.global.email"
                                                          ),
                                                        outlined: "",
                                                        required: "",
                                                        disabled:
                                                          loaders.signUp ||
                                                          loaders.socialSignup,
                                                        "background-color":
                                                          "white",
                                                        "error-messages":
                                                          errors,
                                                        placeholder: _vm.$t(
                                                          "auth.global.enterEmail"
                                                        ),
                                                      },
                                                      model: {
                                                        value:
                                                          forms.signUp.email,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            forms.signUp,
                                                            "email",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "forms.signUp.email",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "password",
                                            rules: "required|min:6",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "auth.global.password"
                                                        ),
                                                        outlined: "",
                                                        required: "",
                                                        disabled:
                                                          loaders.signUp ||
                                                          loaders.socialSignup,
                                                        "background-color":
                                                          "white",
                                                        type: _vm.showPassword
                                                          ? "text"
                                                          : "password",
                                                        placeholder: _vm.$t(
                                                          "auth.global.enterPassword"
                                                        ),
                                                        "error-messages":
                                                          errors,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "append",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.showPassword =
                                                                            !_vm.showPassword
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.showPassword
                                                                                ? _vm
                                                                                    .icons
                                                                                    .mdiEye
                                                                                : _vm
                                                                                    .icons
                                                                                    .mdiEyeOff
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value:
                                                          forms.signUp.password,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            forms.signUp,
                                                            "password",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "forms.signUp.password",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              block: "",
                                              "x-large": "",
                                              color: "primary",
                                              elevation: "0",
                                              disabled:
                                                loaders.signUp ||
                                                loaders.socialSignup ||
                                                invalid,
                                              loading: loaders.signUp,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return signUp()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-outfit-semi-bold button-continue",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("continue"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("auth.global.byContinuing")) + " "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://ideabuddy.com/terms-of-service/",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("auth.global.termsAndConditions"))
                              ),
                            ]
                          ),
                          _vm._v(" " + _vm._s(_vm.$t("auth.global.and")) + " "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://ideabuddy.com/privacy-policy/",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("auth.global.privacyPolicy"))
                              ),
                            ]
                          ),
                          _vm._v(". "),
                        ]),
                        _c("p", { staticClass: "already-have" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("auth.signUpPayment.alreadyHave"))
                            ),
                          ]),
                          _vm._v("   "),
                          _c("a", { on: { click: goToLogin } }, [
                            _vm._v(_vm._s(_vm.$t("auth.signUp.logIn"))),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }